import React from "react";

interface IProp {
  artefact: string
}

export const Artefact = ({ artefact }: IProp) => {
  return <iframe
    width='800px'
    height='350px'
    frameBorder="0"
    scrolling="no"
    src={`https://ar.culture.ru/ru/subject_widget/${artefact}#${JSON.stringify({
      article: true,
      audioguide: true,
      armode: true
    })}`}
  />;

}
